import React, { useCallback, useState } from "react";
import Cropper from "react-easy-crop";
import Button from "../button/Button";
import getCroppedImg from "./cropImage";

const ImageCropper = ({
  onCropImage,
  inputImg,
  imgName,
  closeModal,
  imageAspect,
}) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  /* onCropComplete() will occur each time the user modifies the cropped area, 
    which isn't ideal. A better implementation would be getting the blob 
    only when the user hits the submit button, but this works for now  */

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const showCroppedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(inputImg, croppedAreaPixels);
      onCropImage(
        new File([croppedImage], imgName, {
          type: "image/png",
          lastModified: new Date().getTime(),
        })
      );
    } catch (e) {
      console.error(e);
    }
    // eslint-disable-next-line
  }, [croppedAreaPixels]);

  return (
    /* need to have a parent with `position: relative` 
    to prevent cropper taking up whole page */
    <div className="cropper">
      <Cropper
        image={inputImg}
        crop={crop}
        zoom={zoom}
        aspect={imageAspect}
        onCropChange={setCrop}
        onCropComplete={onCropComplete}
        onZoomChange={setZoom}
        style={{
          containerStyle: {
            width: 400,
            height: 200,
            position: "relative",
          },
        }}
      />

      <div className="d-flex justify-content-between align-items-center mt-5">
        <Button
          type="outline"
          onClick={closeModal}
          label="Cancel"
          className=" mr-3"
        />
        <Button
          onClick={() => {
            showCroppedImage();
            closeModal();
          }}
          label="Save"
          className="btn-block"
        />
      </div>
    </div>
  );
};

export default ImageCropper;
